import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import styled from 'styled-components'

import { Column, Row } from '../Grid'
import { HeaderRendering } from '../Header'
import { Text } from '../Text'

import FooterIntercomClickableHome from 'components/shared/FooterStatic/FooterIntercomClickableHome'
import Wrapper from 'components/Wrapper'

import { navHeight } from 'utils/helpers'

export const TermsLayout = ({ content, metaTags }) => {
	return (
		<Wrapper metaTags={metaTags} cssFile={[]}>
			<HeaderRendering />
			<div style={{ marginTop: navHeight() }}>
				<Row className='items-center justify-center bg-orange-600'>
					<Row className='mx-4 w-full max-w-[1200px] py-6 md:mx-6'>
						<Text variant='big' className='text-xl text-white md:text-2xl'>
							{metaTags?.title}
						</Text>
					</Row>
				</Row>
				<Column className='items-center bg-gray-100'>
					<Content className='m-4 max-w-[1200px] p-4 md:m-6 md:p-6'>
						<ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
					</Content>
				</Column>
			</div>
			<FooterIntercomClickableHome />
		</Wrapper>
	)
}

const Content = styled(Column)`
	text-align: left;
	background: white;
	border-radius: 4px;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;

	h3 {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 24px;
	}

	strong {
		font-weight: bold;
	}
`
